// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"TVChartContainer_clearfix_2nptG","tradingView":"TVChartContainer_tradingView_cP7so"};